import { CommonModule } from '@angular/common';
import { Component, inject, Type } from '@angular/core';
import { AbstractWidget } from '@jeppesen-foreflight/jmkw-toolkit';
import { AbstractDetailComponent } from './abstract-detail.component';
import { AirportDetailComponent } from './airport-detail/airport-detail.component';
import { AirspaceDetailComponent } from './airspace-detail/airspace-detail.component';
import { AirwayDetailComponent } from './airway-detail/airway-detail.component';
import { AmdbDetailComponent } from './amdb-detail/amdb-detail.component';
import { NavaidDetailComponent } from './navaid-detail/navaid-detail.component';
import { RunwayDetailComponent } from './runway-detail/runway-detail.component';
import { WaypointDetailComponent } from './waypoint-detail/waypoint-detail.component';
import { SelectedItemService } from '../selected-item.service';
import { NavigationFeatureType } from '../../typings/navigation-feature-type';
import { FeatureDetail } from '../../typings/features/feature-detail';

const DETAIL_COMPONENTS: Record<
  NavigationFeatureType,
  Type<AbstractDetailComponent>
> = {
  airport: AirportDetailComponent,
  airspace: AirspaceDetailComponent,
  airway: AirwayDetailComponent,
  amdb: AmdbDetailComponent,
  navaid: NavaidDetailComponent,
  runway: RunwayDetailComponent,
  waypoint: WaypointDetailComponent
};

@Component({
  template: `<ng-container
    [ngComponentOutlet]="component"
    [ngComponentOutletInputs]="{ attributes }"
    ]
  ></ng-container>`,
  standalone: true,
  imports: [CommonModule]
})
export class NavWidgetComponent extends AbstractWidget {
  protected selectionSvc = inject(SelectedItemService);
  data!: FeatureDetail;

  get component(): Type<AbstractDetailComponent> {
    return DETAIL_COMPONENTS[this.data.navType];
  }

  get attributes() {
    return this.data.attributes;
  }

  closeWidget?(): void {
    this.selectionSvc.clearExistingSelection();
  }
}
